const GUIDE_PREFIX = "help_guide";
const SCREEN_PREFIX = "help_screen";
const getHelpUserScope = () => {
    if (typeof window === "undefined")
        return "anonymous";
    const email = String(localStorage.getItem("userEmail") ||
        localStorage.getItem("email") ||
        "")
        .trim()
        .toLowerCase();
    return email || "anonymous";
};
const getGuideKey = (guideId, version) => `${GUIDE_PREFIX}@${guideId}@v${version}@${getHelpUserScope()}`;
const getScreenKey = (routeName) => `${SCREEN_PREFIX}@${routeName}@${getHelpUserScope()}`;
export const hasGuidePreference = (guideId, version) => {
    if (typeof window === "undefined")
        return false;
    return Boolean(localStorage.getItem(getGuideKey(guideId, version)));
};
export const getGuidePreference = (guideId, version) => {
    if (typeof window === "undefined")
        return null;
    const raw = localStorage.getItem(getGuideKey(guideId, version));
    if (raw === "completed" || raw === "skipped")
        return raw;
    return null;
};
export const markGuidePreference = (guideId, version, status) => {
    if (typeof window === "undefined")
        return;
    localStorage.setItem(getGuideKey(guideId, version), status);
};
export const isScreenHelpDismissed = (routeName) => {
    if (!routeName || typeof window === "undefined")
        return false;
    return localStorage.getItem(getScreenKey(routeName)) === "dismissed";
};
export const dismissScreenHelp = (routeName) => {
    if (!routeName || typeof window === "undefined")
        return;
    localStorage.setItem(getScreenKey(routeName), "dismissed");
};
export const resetScreenHelpDismissal = (routeName) => {
    if (!routeName || typeof window === "undefined")
        return;
    localStorage.removeItem(getScreenKey(routeName));
};
